import { FCC } from "@/types/common";
import { Stack } from "@mui/material";
import { MenuNavigate } from "@/components/elements/MenuNavigate";
import { Button } from "@/components/elements/Button";
import { JobTitle } from "@/features/job/components/JobTitle";
import { TJobForm } from "@/features/job/types/JobForm";
import { JOB_STATUS } from "@/types/enum";
import { AppRoutes } from "@/routes/config";
import { useNavigate, useParams } from "react-router-dom";
import { JobStatusDetail } from "@/features/job/components/job-detail/JobStatusDetail";
import { JobBasicInfoDetail } from "@/features/job/components/job-detail/JobBasicInfoDetail";
import { JobEmploymentConditionDetail } from "@/features/job/components/job-detail/JobEmploymentConditionDetail";
import { JobWorkingConditionDetail } from "@/features/job/components/job-detail/JobWorkingConditionDetail";
import { JobRequirementDetail } from "@/features/job/components/job-detail/JobRequirementDetail";
import { JobBenefitDetail } from "@/features/job/components/job-detail/JobBenefitDetail";
import { JobFeatureDetail } from "@/features/job/components/job-detail/JobFeatureDetail";
import { JobUploadFilesDetail } from "@/features/job/components/job-detail/JobUploadFilesDetail";
import { JobCaseDetail } from "@/features/job/components/job-detail/JobCaseDetail";
import { getDynamicRoute } from "@/utils/url";
import { pickDuplicateJobData } from "@/features/job/utils/pickDuplicateJobData";
import { FooterContainer } from "@/components/commons/FooterContainer";
import { JOB_WIDTH_FULL } from "@/features/job/constants/width";

type TJobDetailProps = {
  defaultValues?: Partial<TJobForm>;
};
export const JobDetail: FCC<TJobDetailProps> = ({ defaultValues }) => {
  const navigate = useNavigate()
  const { jobId } = useParams();

  const isDraft = defaultValues?.status === JOB_STATUS.DRAFT;
  const toEditRoute = () => {
    const jobEditRoute = getDynamicRoute(AppRoutes.jobEdit, { jobId: jobId });
    navigate(jobEditRoute);
  };

  const handleDuplicateJob = (defaultValues?: Partial<TJobForm>) => {
    if (defaultValues) {
      const key = 'duplicated-job-data';
      const duplicatedJobData = pickDuplicateJobData(defaultValues);
      localStorage.setItem(key, JSON.stringify(duplicatedJobData));
    }

    const jobCreateRoute = getDynamicRoute(AppRoutes.jobCreate, {});
    window.open(jobCreateRoute, "_blank");
  };

  return (
    <>
      <JobTitle
        title={defaultValues?.jobName}
        tag={defaultValues?.tag}
        status={defaultValues?.status}
        createdAt={defaultValues?.createdAt}
        updatedAt={defaultValues?.updatedAt}
      />
      <Stack mt={1} width={`${JOB_WIDTH_FULL}px`}>
        <MenuNavigate
          contents={[
            { title: "ステータス状況", content: <JobStatusDetail defaultValues={defaultValues}  /> },
            { title: "案件参加状況", content: <JobCaseDetail defaultValues={defaultValues}  /> },
            { title: "基本情報", content: <JobBasicInfoDetail defaultValues={defaultValues} isDraft={isDraft} /> },
            { title: "雇用条件", content: <JobEmploymentConditionDetail defaultValues={defaultValues} isDraft={isDraft} />},
            { title: "勤務条件", content: <JobWorkingConditionDetail defaultValues={defaultValues} isDraft={isDraft} /> },
            { title: "応募要件", content: <JobRequirementDetail defaultValues={defaultValues} isDraft={isDraft} /> },
            { title: "福利厚生", content: <JobBenefitDetail defaultValues={defaultValues} /> },
            { title: "特性", content: <JobFeatureDetail defaultValues={defaultValues}  /> },
            { title: "その他関連情報", content: <JobUploadFilesDetail defaultValues={defaultValues}  /> },
          ]}
          contentWidth="900px"
          contentAffix={(
            <FooterContainer>
              <Stack gap={1} direction="row" justifyContent="space-between" alignItems="center">
                <Button variant="ghost" onClick={() => navigate(AppRoutes.jobList)}>
                  戻る
                </Button>
                <Stack direction="row" gap={2}>
                  {/* <Button type="submit" variant="outline" size="sm">
                    パートナーへURL共有
                  </Button> */}
                  <Button type="submit" variant="outline" size="sm" onClick={() => toEditRoute()}>
                    編集
                  </Button>
                  <Button type="submit" variant="primary" size="sm" onClick={() => handleDuplicateJob(defaultValues)}>
                    求人を複製
                  </Button>
                </Stack>
              </Stack>
            </FooterContainer>
          )}
        />
      </Stack>
    </>
  );
};

